export enum BillingModality {
    Invoice = 'INVOICE',
    Credit = 'CREDIT',
}

export const getBillingModalityTranslationId = (value: BillingModality): string => {
    switch (value) {
        case BillingModality.Invoice:
            return 'app.enum.invoice';
        case BillingModality.Credit:
            return 'app.enum.credit';
    }
};
